<div class="input-group">
    <div class="input-group-prepend">
        <!-- XS -->
        <button 
            class="btn btn-light d-sm-none" 
            type="button"
            [popover]="popTemplate" 
            popoverTitle="Gestão de Entrega de Pedido" 
            placement="auto"
            container="body"
            [outsideClick]="true"
            containerClass="pedido-setor-gep-popover"
            title="Ver Histórico"
            tabindex="-1">
                <i class="fas fa-info"></i>
        </button>        
        <!-- Demais-->
        <button 
            class="btn btn-light d-none d-sm-inline-block" 
            type="button"
            [popover]="popTemplate" 
            popoverTitle="Gestão de Entrega de Pedido" 
            placement="bottom"
            container="body"
            [outsideClick]="true"
            containerClass="pedido-setor-gep-popover"
            title="Ver Histórico"
            tabindex="-1">
                <i class="fas fa-info"></i>
        </button>
    </div>
    <input type="text" class="form-control text-center" [value]="entity.setorGep | pedidoSetorGep" name="gep" id="gep"
        disabled="disabled" readonly="readonly">
</div>

<ng-template #popTemplate>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th class="col-setor">Setor</th>
                <th class="col-data">Data</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="col-setor">Representante</td>
                <td class="col-data">{{entity.dataConfirmacao | date:'dd/MM/yyyy - HH:mm'}}</td>
            </tr>
            <tr>
                <td class="col-setor">Confirmação ERP</td>
                <td class="col-data">{{entity.dataIntegracaoErp | date:'dd/MM/yyyy - HH:mm'}}</td>
            </tr>
            <tr>
                <td class="col-setor">Análise Financeiro</td>
                <td class="col-data">{{entity.dataAnaliseFinanceiro | date:'dd/MM/yyyy - HH:mm'}}</td>
            </tr>
            <tr *ngIf="entity.dataCancelamento">
                <td class="col-setor">Cancelado</td>
                <td class="col-data">{{entity.dataCancelamento | date:'dd/MM/yyyy - HH:mm'}}</td>
            </tr>   
            
            <tr *ngIf="entity.dataInicioAguardandoProducao">
                <td class="col-setor">Inicio Aguardando Produção</td>
                <td class="col-data">{{entity.dataInicioAguardandoProducao | date:'dd/MM/yyyy - HH:mm'}}</td>
            </tr>   
            <tr *ngIf="entity.dataTerminoAguardandoProducao">
                <td class="col-setor">Término Aguardando Produção</td>
                <td class="col-data">{{entity.dataTerminoAguardandoProducao | date:'dd/MM/yyyy - HH:mm'}}</td>
            </tr>               

            <tr>
                <td class="col-setor">Liberado Expedição</td>
                <td class="col-data">{{entity.dataLiberadoExpedicao | date:'dd/MM/yyyy - HH:mm'}}</td>
            </tr>
            <tr>
                <td class="col-setor">Liberado Faturamento</td>
                <td class="col-data">{{entity.dataLiberadoFaturamento | date:'dd/MM/yyyy - HH:mm'}}</td>
            </tr>
            <tr>
                <td class="col-setor">Liberado Coleta</td>
                <td class="col-data">{{entity.dataLiberadoColeta | date:'dd/MM/yyyy - HH:mm'}}</td>
            </tr>
            <tr>
                <td class="col-setor">Coletado</td>
                <td class="col-data">{{entity.dataColeta | date:'dd/MM/yyyy - HH:mm'}}</td>
            </tr>
            <tr>
                <td class="col-setor">Entregue</td>
                <td class="col-data">{{entity.dataEntrega | date:'dd/MM/yyyy - HH:mm'}}</td>
            </tr>                                      
        </tbody>
    </table>
</ng-template>